import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Image,
  useToast,
} from "@chakra-ui/react";
import api from "../config/axios";
import Webcam from "react-webcam";

const ResetEmailPage = () => {
  const [previousEmail, setPreviousEmail] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false); // Manage camera activation

  const toast = useToast();
  const webcamRef = useRef(null);

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      // Convert base64 to a Blob (image file)
      const base64Data = imageSrc.split(",")[1];
      const binaryData = atob(base64Data);
      const arrayBuffer = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        arrayBuffer[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([arrayBuffer], { type: "image/jpeg" });
      const imageFile = new File([blob], "photo.jpeg", { type: "image/jpeg" }); // Ensure the file is saved as 'photo.jpeg'

      setPhoto(imageFile); // Store the file object
      setPhotoPreview(imageSrc); // For preview
      setIsCameraOpen(false); // Turn off camera
    } else {
      toast({
        title: "Error",
        description: "Could not capture photo. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSubmit = async () => {
    if (!previousEmail || !newEmail || !phone || !photo) {
      toast({
        title: "Error",
        description: "Please fill in all the fields and capture a photo.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const formData = new FormData();
    formData.append("previous_email", previousEmail);
    formData.append("email", newEmail);
    formData.append("mobile", phone);
    formData.append("photo", photo); // The photo now has the name "photo.jpeg"

    try {
      const response = await api.post(
        "/update_user_email_mobile", 
        formData, 
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (response.data) {
        toast({
          title: "Success",
          description: "Your email has been successfully updated.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setPreviousEmail("");
        setNewEmail("");
        setPhone("");
        setPhoto(null);
        setPhotoPreview(null);
      } else {
        toast({
          title: "Error",
          description: "Failed to update email. Please try again.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
     } catch (error) {
      console.error("Error updating email:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box
      maxW="md"
      mx="auto"
      mt="10"
      p="5"
      borderWidth="1px"
      borderRadius="md"
      boxShadow="md"
    >
      <VStack spacing="5">
        <FormControl isRequired>
          <FormLabel>Previous Email</FormLabel>
          <Input
            type="email"
            placeholder="Enter your previous email"
            value={previousEmail}
            onChange={(e) => setPreviousEmail(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>New Email</FormLabel>
          <Input
            type="email"
            placeholder="Enter your new email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Phone</FormLabel>
          <Input
            type="tel"
            placeholder="Enter your phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Capture Photo</FormLabel>
          {photoPreview ? (
            <Image
              src={photoPreview}
              alt="Captured Photo Preview"
              boxSize="100px"
              mt="3"
              borderRadius="md"
            />
          ) : (
            <Button
              colorScheme="blue"
              onClick={() => setIsCameraOpen(true)}
              mt="3"
              isFullWidth
            >
              Click to Capture 
            </Button>
          )}

          {isCameraOpen && (
            <Box mt="3" textAlign="center">
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width="100%"
                height="200px"
              />
              <Button mt="3" onClick={capturePhoto} colorScheme="blue">
                Capture Photo
              </Button>
              <Button
                mt="3"
                onClick={() => setIsCameraOpen(false)}
                colorScheme="red"
              >
                Close Camera
              </Button>
            </Box>
          )}
        </FormControl>

        <Button colorScheme="blue" onClick={handleSubmit} isFullWidth>
          Reset Email
        </Button>
      </VStack>
    </Box>
  );
};

export default ResetEmailPage;
